export const userDragNoneStyle = `
  user-drag: none; 
`;